@if (tellentAssistantFlag()) {
  <button class="trigger" type="button" (click)="service.toggle()">
    <tellent-assistant-brand-mark [size]="28" />
  </button>
}
